import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getPriorityLabel = (priority) => {
  const labels = {
    baja: 'Baja',
    media: 'Media',
    alta: 'Alta',
    critica: 'Crítica',
  };
  return labels[priority] || priority;
};

export const getStatusLabel = (status) => {
  const labels = {
    pendiente: 'Pendiente',
    en_curso: 'En curso',
    bloqueada: 'Bloqueada',
    hecha: 'Hecha',
  };
  return labels[status] || status;
};

export const getHospitalizationTypeLabel = (type) => {
  const labels = {
    infeccioso: 'Infeccioso',
    no_infeccioso: 'No Infeccioso',
    postquirurgico: 'Postquirúrgico',
  };
  return labels[type] || type;
};

export const getShiftTypeLabel = (type) => {
  const labels = {
    manana: 'Mañana',
    tarde: 'Tarde',
    noche: 'Noche',
    guardia: 'Guardia',
  };
  return labels[type] || type;
};

export const getRoleLabel = (role) => {
  const labels = {
    admin: 'Administrador',
    vet: 'Veterinario',
    atv: 'ATV',
    aux: 'Auxiliar',
    recepcion: 'Recepción',
  };
  return labels[role] || role;
};

// Safe print utility - replaces document.write with DOM manipulation
export const printContent = (elementId, title = 'Benivet Ops') => {
  const content = document.getElementById(elementId);
  if (!content) return;
  safePrintHtml(content.innerHTML, title);
};

// Generic safe print HTML utility for all report pages
// Uses Blob URL instead of document.write for XSS safety
export const safePrintHtml = (htmlContent, title = 'Benivet Ops', customCss = '') => {
  const safeTitle = (title || '').replace(/[<>]/g, '');
  const fullHtml = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>' + safeTitle + '</title><style>' + customCss + '</style></head><body>' + htmlContent + '</body></html>';
  const blob = new Blob([fullHtml], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const printWindow = window.open(url, '_blank');
  if (!printWindow) { URL.revokeObjectURL(url); return; }
  printWindow.onload = () => { printWindow.print(); URL.revokeObjectURL(url); };
};

// Copy to clipboard utility
export const copyToClipboard = async (text, successMessage = 'Copiado al portapapeles') => {
  try {
    await navigator.clipboard.writeText(text);
    return { success: true, message: successMessage };
  } catch (err) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return { success: true, message: successMessage };
    } catch (e) {
      document.body.removeChild(textArea);
      return { success: false, message: 'Error copiando al portapapeles' };
    }
  }
};

// Convert HTML to plain text for copying (uses DOMParser for safety)
export const htmlToPlainText = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};
